import { createStore } from 'vuex'
import { FusionPlugin } from '@/services/toolServices/Fusion360Service.js';
import { WebPlugin } from '@/services/toolServices/WebToolService.js';
import { gtmPlugin } from '@/services/auxServices/gtmService.js';
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '@/config/oidc'

export default createStore({
    state: {
        instance: "web",
        version: 1,
        errorMessage: "",
        globalError: [],
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
        search: {
            mfrId: "",
            text: "",
            page: 1,
            type: "external"
        },
        reference: {
            mfrIds: [],
            text: "",
            page: 1
        },
        request: {
            manufacturer: "",
            partNumber: "",
        },
        user: {
            exportOptions: [],
            displayName: "",
            confirmed: false
        },
        navigation: {
            currentPanel: "start",
            selectedPuid: "",
            selectedEuid: "",
            backLink: "",
            searchBackLink: "",
            offsiteUrl: "",
            returnUrl: ""
        },
        export: {
            token: "",
            useActive: false
        },
        profile: {
            downloadLocation: "",
            targetProfiles: []
        },
        activeProfile: null,
        activeProfileValid: false,
        openLibraries: []
    },
    mutations: {
        SET_INSTANCE(state, instance) {
            state.instance = instance;
        },
        CHANGE_PANEL(state, newPanel) {
            state.navigation.currentPanel = newPanel;
        },
        CHANGE_SEARCH_TYPE(state, newSearchType) {
            state.search.type = newSearchType;
        },
        SEARCH_START() {
        },
        SEARCH_COMPLETE() {
        },
        CLEAR_PART_NUMBER(state) {
            state.navigation.selectedPuid = "";
            state.navigation.selectedEuid = "";
        },
        DOWNLOAD_COMPLETE(state) {
            state.navigation.selectedPuid = "";
            state.navigation.selectedEuid = "";
        },
        DOWNLOAD_FILE(state, { exportToken, useActive }) {
            state.export.token = exportToken;
            state.export.useActive = useActive;
        },
        CLEAR_GLOBAL_ERROR(state) {
            state.globalError = [];
        },
        SET_GLOBAL_ERROR(state, error) {
            state.globalError.push(error);
        },
        CANCEL_EXPORT() {
        },
        SEARCH_SET() {
        },
        CLEAR_SEARCH_LOAD() {
        },
        SET_SEARCH_VALUES(state, newSearchContent) {
            state.search.type = newSearchContent.searchType;
            state.search.mfrId = newSearchContent.searchManufacturerId;
            state.search.text = newSearchContent.searchText;
            state.search.page = newSearchContent.page;
        },
        SET_REFERENCE_VALUES(state, newReferenceSearch) {
            state.reference.mfrIds = newReferenceSearch.selectedMfrIds;
            state.reference.text = newReferenceSearch.searchText;
            state.reference.page = newReferenceSearch.page;
        },
        SET_BACKLINK(state, backlink) {
            state.navigation.backLink = backlink;
        },
        SET_SEARCH_BACKLINK(state, backlink) {
            state.navigation.searchBackLink = backlink;
        },
        SET_RETURNURL(state, returnUrl) {
            state.navigation.returnUrl = returnUrl;
        },
        SELECT_PART_NUMBER(state, newSelection) {
            state.navigation.selectedPuid = newSelection.puid;
            state.navigation.selectedEuid = newSelection.euid;
        },
        SET_ERROR(state, message) {
            state.errorMessage = message;
        },
        LOAD_CONSENT() {
        },
        LOAD_OPTIONS() {
        },
        LOAD_EXPORTS() {
        },
        GET_VERSION(state, version) {
            if (version)
                state.version = version;
        },
        GET_PROFILE(state, profile) {
            if (profile && typeof (profile) != undefined)
                state.profile = JSON.parse(JSON.stringify(profile));
            else
                state.profile = { downloadLocation: "", targetProfiles: [] };
        },
        SET_OPEN_LIBRARIES(state, libraries) {
            state.openLibraries = JSON.parse(JSON.stringify(libraries));
        },
        SET_ACTIVE_LIBRARY(state, content) {
            state.activeProfile = content.profile;
            state.activeProfileValid = typeof (content.valid) != undefined && content.valid;
        },
        SET_OFFSITE_URL(state, offsiteUrl) {
            state.navigation.offsiteUrl = offsiteUrl;
        },
        SET_USER_SETTINGS(state, content) {
            state.user.exportOptions = content;
        },
        SET_USERCONFIRMED(state) {
            state.user.confirmed = true;
        },
        SIGN_OUT() { },
        SET_PROFILE_RETURN(retuuid) {
        }
    },
    actions: {
        //GTM Holder Actions 
        gtmNewAccess() { },
        gtmSubmitRegistration() { },
        gtmConfirmRegistration() { },
        gtmDownloadComplete() { },
        gtmDownloadFailure() { },
        gtmReferenceInfluence() { },
        gtmReferenceDownload() { },
        gtmSearch() { },
        gtmPartLoaded() { },
        gtmInfluenceSearch() { },

        gtmCompatiblePart() { },
        gtmCompatibleExternal() { },
        gtmCompatibleInternal() { },

        gtmCompetitivePart() { },
        gtmCompetitiveExternal() { },
        gtmCompetitiveInternal() { },

        //Tool content actions
        siteLoaded({ state }) {
            if (state.oidcStore.user)
                this.dispatch('gtmNewAccess', { userId: state.oidcStore.user.sub });
            else
                this.dispatch('gtmNewAccess');
        },
        refreshProfile() {
        },
        getActiveLibrary() {
        },
        getProjectDropdown() {
        },
        getLibraryDropdown() {
        },
        setUserProfile() {
        },
        executeSearch({ commit }, { type, mfr, text, page }) {
            var mfrId = "";
            var searchTerm = "";
            if (typeof (mfr) != undefined && mfr && mfr != null) {
                mfrId = mfr;
            }
            if (typeof (text) != undefined && text && text != null) {
                searchTerm = text;
            }

            commit('CLEAR_PART_NUMBER');
            commit('SET_SEARCH_VALUES', { searchType: type, searchManufacturerId: mfrId, searchText: searchTerm, searchPage: page });
            commit('CHANGE_PANEL', 'search');
        },
        selectPart({ commit }, selectPart) {
            commit('CHANGE_PANEL', 'placeholder');
            commit('SELECT_PART_NUMBER', selectPart);
        },
        downloadStart({ commit }, { exportToken, useActive }) {
            commit('DOWNLOAD_FILE', { exportToken, useActive });
        },
        goToStart({ commit }) {
            commit('CHANGE_PANEL', 'start');
        },
        downloadComplete() {
        },
        downloadFailure() {
        },
        downloadReference() {
        },
        setOffsiteUrl({ commit }, offsiteUrl) {
            commit('SET_OFFSITE_URL', offsiteUrl);
        },
        openUrl() {
        }
    },
    modules: {
        oidcStore: vuexOidcCreateStoreModule(
            oidcSettings,
            // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
            // spread your oidcSettings and define a userStore of your choice
            // {
            //   ...oidcSettings,
            //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
            // },
            // Optional OIDC store settings
            {
                namespaced: true,
                dispatchEventsOnWindow: true
            },
            // Optional OIDC event listeners
            {
                //On login check for completed registration, if incomplete redirect to force completion
                //userLoaded: async (user) => {
                //    if (!(user.profile.role && (user.profile.role == 'RegisteredUser' || user.profile.role.includes('RegisteredUser')))) {
                //        await router.isReady();
                //        router.push({ name: 'CompleteRegister' });
                //    }
                //},
                //userUnloaded: () => console.log('OIDC user is unloaded'),
                //accessTokenExpiring: () => console.log('Access token will expire'),
                //accessTokenExpired: () => console.log('Access token did expire'),
                //silentRenewError: () => console.log('OIDC user is unloaded'),
                //userSignedOut: () => console.log('OIDC user is signed out'),
                //oidcError: (payload) => console.log('OIDC error', payload),
                //automaticSilentRenewError: (payload) => console.log('OIDC automaticSilentRenewError', payload)
            }
        )
    },
    plugins: [
        FusionPlugin,
        WebPlugin,
        gtmPlugin
    ]
})